export function mobileSearchButton() {
    const mobileSearchButton = document.querySelector('.farlo-nav-search__mobile');
    const searchElement = document.querySelector('.farlo-nav-search');

    if (mobileSearchButton && searchElement) {
        mobileSearchButton.addEventListener('click', function () {
            if (window.innerWidth <= 768) { // Adjust breakpoint as needed
                searchElement.classList.toggle('farlo-nav-search--active');
            }
        });
    }
}